import {createContext} from 'react';

import type {NotificationService} from '../services/Notification.service';

export const NotificationContext = createContext<
    NotificationService | undefined
>(undefined);
